import React from "react";

const AppContext = React.createContext('appContext');
export const { Provider, Consumer } = AppContext;

export default AppContext;